/**
 * 路由路径单源 —— dosia.catatech.cn 单域名路径路由（deploy/dosia-website-domain-cutover.md）：
 * `/` 官网 · `/admin/*` 平台超管面 · `/org/:orgCode/*` 企业租户面（如 /org/catalyst）。
 * 租户挂 /org 前缀：与官网未来新页面（行业方案 tab 等）永久隔离命名空间，
 * 免去组织码保留字黑名单随官网页面增长。绝对跳转一律引用这里，禁散落字符串。
 */
export const ADMIN_BASE = "/admin";
export const ADMIN_LOGIN = `${ADMIN_BASE}/login`;
export const ADMIN_ORGS = `${ADMIN_BASE}/organizations`;
export const ADMIN_ONBOARDING = `${ADMIN_BASE}/onboarding`;
/** L1.5 平台策展-主脑清单（super-only 平台面，非 org-scoped）。 */
export const ADMIN_BRAIN_CURATION = `${ADMIN_BASE}/brain-curation`;
/** L1.5 平台策展-工具模型清单（super-only 平台面，非 org-scoped）。 */
export const ADMIN_TOOL_CURATION = `${ADMIN_BASE}/tool-curation`;
/** pi 策展平台级（super-only 平台面，非 org-scoped —— 全平台单份「pi 母语引擎」白名单）。 */
export const ADMIN_PI_CURATION = `${ADMIN_BASE}/pi-curation`;
/** 平台级档位映射（super-only 平台面，非 org-scoped —— 全平台单份档位表）。 */
export const ADMIN_TIER_MAPPING = `${ADMIN_BASE}/tier-mapping`;
/** 全量模型/分组/协议统一治理页（旧 brain/pi/tier/tool 路径均 redirect）。 */
export const ADMIN_MODEL_GOVERNANCE = `${ADMIN_BASE}/model-governance`;
/** 「模型清单」数据枢纽页（P3，super-only 平台面，非 org-scoped）——网关全量数据只读展示，
 *  三个模型池（Claude SDK 主脑 / pi 框架主脑 / 工具模型）的唯一取数处。池准入编辑仍在
 *  ADMIN_MODEL_GOVERNANCE。 */
export const ADMIN_MODEL_CATALOG_HUB = `${ADMIN_BASE}/model-catalog`;
/** Skill Hub 平台 Catalog 管理（super-only 平台面，非 org-scoped —— 创建/上传/校验/发布/撤下/回滚）。 */
export const ADMIN_SKILL_HUB = `${ADMIN_BASE}/skill-hub`;
/** 平台能力总库（P0C，super/support 只读；硬门 requireSuper；供给包生命周期仍走 Skill Hub）。 */
export const ADMIN_CAPABILITIES = `${ADMIN_BASE}/capabilities`;

/** 平台面组织详情深链（sub 不带前导斜杠），对称 tenantPath */
export function adminOrgPath(orgCode: string, sub?: string): string {
  return `${ADMIN_ORGS}/${orgCode}${sub ? `/${sub}` : ""}`;
}

export const TENANT_BASE = "/org";
/** 租户后台入口/深链（sub 不带前导斜杠） */
export function tenantPath(orgCode: string, sub?: string): string {
  return `${TENANT_BASE}/${orgCode}${sub ? `/${sub}` : ""}`;
}
